import {useEffect} from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {Alert, Snackbar, IconButton, Grid, createTheme, ThemeProvider, Grow} from '@mui/material';
import Lottie from 'lottie-react';
import {bool, func, number, string} from 'prop-types';

import animationFile from '../../lotties/spinner/whiteSpinnerAnimation.json';
import parentTheme from '../../styles/mui-theme';

const theme = createTheme({
  ...parentTheme,
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          pointerEvents: 'auto',
          display: 'flex',
          alignItems: 'center',
          color: 'white'
        },
        message: {
          display: 'flex',
          alignItems: 'center',
          color: 'white'
        }
      }
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          pointerEvents: 'none'
        }
      }
    }
  }
});

const GrowTransition = props => {
  // eslint-disable-next-line react/prop-types
  return <Grow {...props} />;
};

const CustomSnackbar = ({marginTop, isOpen = false, onClose, duration = 4000, text, severity = 'success', hasSpinner = false}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  // This is a workaround to force snackbar to close if window loses focus
  useEffect(() => {
    const handleBlur = () => {
      if (isOpen && duration !== null) {
        setTimeout(() => onClose(null, 'timeout'), duration);
      }
    };
    window.addEventListener('blur', handleBlur);
    return () => {
      window.removeEventListener('blur', handleBlur);
    };
  }, [isOpen, onClose]);

  return (
    <ThemeProvider theme={theme}>
      <Snackbar sx={{marginTop}} TransitionComponent={GrowTransition} anchorOrigin={{vertical: 'top', horizontal: 'center'}} open={isOpen} autoHideDuration={duration} onClose={handleClose}>
        <Alert
          variant="filled"
          severity={severity}
          icon={hasSpinner ? false : undefined}
          action={
            <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {hasSpinner && (
            <Grid mr={1.5}>
              <Lottie style={{height: 22, width: 22}} loop animationData={animationFile} />
            </Grid>
          )}

          {text}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
};

CustomSnackbar.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
  duration: number,
  text: string.isRequired,
  severity: string,
  hasSpinner: bool,
  marginTop: number
};

export default CustomSnackbar;
